import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { db } from '../../firebase/firebase-config';
import Swal from 'sweetalert2';

const CATEGORIAS_SUGERIDAS = ['Uñas', 'Cabello', 'Pestañas', 'Cejas', 'Maquillaje', 'Faciales', 'Masajes', 'Depilación', 'Micropigmentación', 'Otros'];

const servicioVacio = (categoria = '') => ({
    servicio: '', precio: '', precioMaximo: '', duracion: 30,
    capacidad: '1', descripcion: '', imagen: '',
    montoAnticipo: 0, porcentajeAnticipo: 0, orden: 0,
    pidaAnticipo: false, categoria,
});

// ── Formulario de servicio ────────────────────────────────────────────────────
const FormServicio = ({ servicio, onChange, onGuardar, onCancelar, manejaAnticipo, categorias }) => {
    const horas = Math.floor(servicio.duracion / 60);
    const mins = servicio.duracion % 60;
    const [precioVariable, setPrecioVariable] = React.useState(!!servicio.precioMaximo);

    const adjDur = (delta) => onChange({ ...servicio, duracion: Math.max(5, Math.min(480, servicio.duracion + delta * 5)) });
    const handleHorasInput = (val) => onChange({ ...servicio, duracion: Math.max(5, Math.max(0, Math.min(8, parseInt(val) || 0)) * 60 + mins) });
    const handleMinsInput = (val) => onChange({ ...servicio, duracion: Math.max(5, horas * 60 + Math.max(0, Math.min(55, Math.round((parseInt(val) || 0) / 5) * 5))) });

    const limiteAnticipo = parseInt(servicio.precioMaximo || servicio.precio) || 0;
    const inputDurStyle = { width: '100%', textAlign: 'center', border: '0.5px solid var(--border)', borderRadius: 10, fontSize: 24, fontWeight: 600, color: 'var(--pink-900)', padding: '10px 0', background: 'var(--pink-100)', outline: 'none', WebkitAppearance: 'none', MozAppearance: 'textfield' };

    return (
        <div style={{ background: 'var(--pink-50)', border: '0.5px solid var(--border)', borderRadius: 12, padding: 16, marginTop: 8 }}>
            <div className="field-label" style={{ marginTop: 0 }}>Nombre del servicio</div>
            <input className="field-input" placeholder="Ej. Manicura con gel" value={servicio.servicio}
                onChange={e => onChange({ ...servicio, servicio: e.target.value })} autoFocus />

            {categorias.length > 0 && (
                <>
                    <div className="field-label">Categoría</div>
                    <select className="field-input" value={servicio.categoria}
                        onChange={e => onChange({ ...servicio, categoria: e.target.value })}>
                        <option value="">Sin categoría</option>
                        {categorias.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                </>
            )}

            <div className="field-label">Precio</div>
            <div className="price-wrap">
                <span className="price-symbol">$</span>
                <input className="field-input price-input" placeholder="0" type="tel" inputMode="numeric"
                    value={servicio.precio} onChange={e => onChange({ ...servicio, precio: e.target.value.replace(/\D/g, '') })} />
            </div>

            <div className="toggle-row" style={{ marginTop: 10 }}>
                <div>
                    <div className="toggle-label">¿El precio varía?</div>
                    <div className="toggle-sub">Ej: pelo corto $200, largo $350</div>
                </div>
                <div className={`toggle ${precioVariable ? 'on' : ''}`}
                    onClick={() => { setPrecioVariable(!precioVariable); if (precioVariable) onChange({ ...servicio, precioMaximo: '' }); }}>
                    <div className="toggle-thumb" />
                </div>
            </div>
            {servicio.precioMaximo !== '' && (
                <>
                    <div className="field-label">Precio máximo</div>
                    <div className="price-wrap">
                        <span className="price-symbol">$</span>
                        <input className="field-input price-input" placeholder="0" type="tel" inputMode="numeric"
                            value={servicio.precioMaximo} onChange={e => onChange({ ...servicio, precioMaximo: e.target.value.replace(/\D/g, '') })} />
                    </div>
                    <p className="field-hint">Deja vacío si el precio es fijo</p>
                </>
            )}

            <div className="field-label">Duración</div>
            <div className="duration-row">
                <div className="duration-col">
                    <input type="number" min="0" max="8" value={horas} onChange={e => handleHorasInput(e.target.value)} style={inputDurStyle} />
                    <div className="duration-label">horas</div>
                </div>
                <div style={{ color: 'var(--pink-200)', fontSize: 22, paddingTop: 4 }}>:</div>
                <div className="duration-col">
                    <input type="number" min="0" max="55" step="5" value={String(mins).padStart(2, '0')} onChange={e => handleMinsInput(e.target.value)} style={inputDurStyle} />
                    <div className="duration-label">minutos</div>
                </div>
                <div className="duration-controls">
                    <button className="dur-btn" onClick={() => adjDur(1)}>+</button>
                    <button className="dur-btn" onClick={() => adjDur(-1)}>−</button>
                </div>
            </div>
            <p style={{ fontSize: 12, color: 'var(--pink-800)', marginTop: 4, textAlign: 'center' }}>Total: {servicio.duracion} minutos</p>

            {manejaAnticipo && (
                <>
                    <div className="toggle-row" style={{ marginTop: 10 }}>
                        <div>
                            <div className="toggle-label">Este servicio pide anticipo</div>
                            <div className="toggle-sub">La clienta paga antes de confirmar</div>
                        </div>
                        <div className={`toggle ${servicio.pidaAnticipo ? 'on' : ''}`}
                            onClick={() => onChange({ ...servicio, pidaAnticipo: !servicio.pidaAnticipo, montoAnticipo: 0 })}>
                            <div className="toggle-thumb" />
                        </div>
                    </div>
                    {servicio.pidaAnticipo && (
                        <>
                            <div className="field-label">Monto del anticipo</div>
                            <div className="price-wrap">
                                <span className="price-symbol">$</span>
                                <input className="field-input price-input" placeholder="0" type="tel" inputMode="numeric"
                                    value={servicio.montoAnticipo || ''}
                                    onChange={e => onChange({ ...servicio, montoAnticipo: parseInt(e.target.value.replace(/\D/g, '')) || 0 })} />
                            </div>
                            {limiteAnticipo > 0 && servicio.montoAnticipo >= limiteAnticipo && (
                                <p className="field-error">El anticipo debe ser menor al precio</p>
                            )}
                        </>
                    )}
                </>
            )}

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 16 }}>
                <button className="btn-outline" onClick={onCancelar}>Cancelar</button>
                <button className="btn-primary" style={{ marginTop: 0 }} onClick={onGuardar}>Guardar</button>
            </div>
        </div>
    );
};

// ── Pantalla principal ────────────────────────────────────────────────────────
export const ServiciosScreen = ({ onBack }) => {
    const { hashtag } = useSelector(state => state.auth);
    const [servicios, setServicios] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [mostrarCategorias, setMostrarCategorias] = useState(true);
    const [nuevaCategoria, setNuevaCategoria] = useState('');
    const [agregando, setAgregando] = useState(false);
    const [agregandoEnCategoria, setAgregandoEnCategoria] = useState(null);
    const [editando, setEditando] = useState(null);
    const [svcActual, setSvcActual] = useState(servicioVacio());
    const [manejaAnticipo, setManejaAnticipo] = useState(false);
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        const cargar = async () => {
            try {
                const catSnap = await db.doc(`general/${hashtag}/servicios/catalogo`).get();
                if (catSnap.exists) setServicios(catSnap.data().servicios || []);

                const empSnap = await db.doc(`general/${hashtag}`).get();
                const data = empSnap.data() || {};
                if (data.clasificaciones) {
                    setCategorias(data.clasificaciones.split(';').map(p => p.split('/')[0]));
                }
                // Detectar si maneja anticipo
                if (data.spei?.a_nombre_de && data.spei.a_nombre_de !== 'X') {
                    setManejaAnticipo(true);
                }
            } catch (e) {
                console.log('Error:', e);
            } finally {
                setCargando(false);
            }
        };
        cargar();
    }, [hashtag]);

    // Propagar cambios a consultores
    const propagarAConsultores = async (servicioActualizado, eliminado = false, nombreAnterior = null) => {
        const nombreBusqueda = nombreAnterior || servicioActualizado.servicio;
        try {
            const colSnap = await db.collection(`general/${hashtag}/consultores`).get();
            for (const colDoc of colSnap.docs) {
                const listaSnap = await db.doc(`general/${hashtag}/consultores/${colDoc.id}/servicios/lista`).get();
                if (!listaSnap.exists) continue;
                const lista = listaSnap.data().servicios || [];
                const tieneServicio = lista.some(s => s.servicio === nombreBusqueda);
                if (!tieneServicio) continue;

                let nuevaLista;
                if (eliminado) {
                    nuevaLista = lista.filter(s => s.servicio !== nombreBusqueda);
                } else {
                    nuevaLista = lista.map(s => s.servicio === nombreBusqueda
                        ? { ...s, servicio: servicioActualizado.servicio, precio: servicioActualizado.precio, precioMaximo: servicioActualizado.precioMaximo, duracion: String(servicioActualizado.duracion), montoAnticipo: servicioActualizado.montoAnticipo, porcentajeAnticipo: 0 }
                        : s
                    );
                }
                await db.doc(`general/${hashtag}/consultores/${colDoc.id}/servicios/lista`).update({ servicios: nuevaLista });
            }
        } catch (e) {
            console.log('Error propagando:', e);
        }
    };

    const persistir = async (nuevosServicios, nuevasCategorias) => {
        const cats = nuevasCategorias ?? categorias;
        let orden = 1;
        const reordenados = [...nuevosServicios];
        cats.forEach(cat => reordenados.filter(s => s.categoria === cat).forEach(s => { s.orden = orden++; }));
        reordenados.filter(s => !s.categoria || !cats.includes(s.categoria)).forEach(s => { s.orden = orden++; });

        await db.doc(`general/${hashtag}/servicios/catalogo`).set({ servicios: reordenados });

        if (cats.length > 0) {
            let cadena = '';
            let n = 1;
            cats.forEach(cat => {
                const count = reordenados.filter(s => s.categoria === cat).length;
                if (count > 0) { if (cadena) cadena += ';'; cadena += `${cat}/${n}-${n + count - 1}`; n += count; }
            });
            if (cadena) await db.doc(`general/${hashtag}`).update({ clasificaciones: cadena });
        }
        return reordenados;
    };

    const handleGuardar = async () => {
        if (!svcActual.servicio.trim()) { Swal.fire('Falta el nombre', 'Escribe el nombre del servicio.', 'warning'); return; }
        if (!svcActual.precio) { Swal.fire('Falta el precio', 'Agrega el precio del servicio.', 'warning'); return; }
        if (categorias.length > 0 && !svcActual.categoria) { Swal.fire('Falta la categoría', 'Selecciona a qué categoría pertenece este servicio para que tus clientas lo encuentren en WhatsApp.', 'warning'); return; }

        const svcFinal = {
            servicio: svcActual.servicio.trim(), precio: svcActual.precio,
            precioMaximo: svcActual.precioMaximo || '', duracion: String(svcActual.duracion),
            capacidad: '1', descripcion: '', imagen: '',
            montoAnticipo: svcActual.pidaAnticipo ? (svcActual.montoAnticipo || 0) : 0,
            porcentajeAnticipo: 0, orden: 0, categoria: svcActual.categoria || '',
        };

        const esEdicion = editando !== null;
        const svcAnterior = esEdicion ? servicios[editando] : null;

        let nuevos;
        if (esEdicion) {
            nuevos = [...servicios];
            nuevos[editando] = svcFinal;
        } else {
            nuevos = [...servicios, svcFinal];
        }

        const reordenados = await persistir(nuevos);
        setServicios(reordenados);

        if (esEdicion && svcAnterior) {
            // Edición: propagar cambios a consultores que ya lo tienen
            await propagarAConsultores(svcFinal, false, svcAnterior.servicio);
        } else if (!esEdicion) {
            // Nuevo servicio: asignar a colaboradoras
            const colSnap = await db.collection(`general/${hashtag}/consultores`).get();
            const cols = colSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            if (cols.length === 1) {
                // Una sola colaboradora → asignar automáticamente
                const col = cols[0];
                const listaSnap = await db.doc(`general/${hashtag}/consultores/${col.id}/servicios/lista`).get();
                const listaActual = listaSnap.exists ? (listaSnap.data().servicios || []) : [];
                await db.doc(`general/${hashtag}/consultores/${col.id}/servicios/lista`).set({
                    servicios: [...listaActual, svcFinal]
                });
                await db.doc(`general/${hashtag}/consultores/${col.id}`).update({ noServicios: listaActual.length + 1 });
            } else if (cols.length > 1) {
                // Múltiples colaboradoras → preguntar
                const opciones = cols.map(c => `<label style="display:flex;align-items:center;gap:10px;padding:8px 0;font-size:15px">
                    <input type="checkbox" value="${c.id}" style="width:18px;height:18px" checked />
                    ${c.id.replace('@', '')}
                </label>`).join('');

                const { isConfirmed, value } = await Swal.fire({
                    title: '¿A quién asignar este servicio?',
                    html: `<div style="text-align:left;padding:0 8px">${opciones}</div>`,
                    confirmButtonText: 'Asignar',
                    confirmButtonColor: '#D4537E',
                    showCancelButton: true,
                    cancelButtonText: 'Ninguna por ahora',
                    preConfirm: () => {
                        const checks = Swal.getPopup().querySelectorAll('input[type=checkbox]:checked');
                        return Array.from(checks).map(c => c.value);
                    }
                });

                if (isConfirmed && value && value.length > 0) {
                    for (const colId of value) {
                        const listaSnap = await db.doc(`general/${hashtag}/consultores/${colId}/servicios/lista`).get();
                        const listaActual = listaSnap.exists ? (listaSnap.data().servicios || []) : [];
                        await db.doc(`general/${hashtag}/consultores/${colId}/servicios/lista`).set({
                            servicios: [...listaActual, svcFinal]
                        });
                        await db.doc(`general/${hashtag}/consultores/${colId}`).update({ noServicios: listaActual.length + 1 });
                    }
                }
            }
        }

        setEditando(null);
        setSvcActual(servicioVacio());
        setAgregando(false);
        setAgregandoEnCategoria(null);
        Swal.fire({ icon: 'success', title: esEdicion ? 'Servicio actualizado' : 'Servicio agregado', timer: 1200, showConfirmButton: false });
    };

    const handleEliminar = async (idx) => {
        const { isConfirmed } = await Swal.fire({
            title: '¿Eliminar servicio?',
            text: 'Se eliminará de todos los consultores que lo tengan asignado.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#D4537E',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        });
        if (!isConfirmed) return;

        const svc = servicios[idx];
        const nuevos = servicios.filter((_, i) => i !== idx);
        const reordenados = await persistir(nuevos);
        setServicios(reordenados);
        await propagarAConsultores(svc, true);
    };

    const handleEditar = (idx) => {
        setEditando(idx);
        const s = servicios[idx];
        setSvcActual({ ...s, duracion: parseInt(s.duracion) || 30, pidaAnticipo: (s.montoAnticipo || 0) > 0 });
        setAgregando(false);
        setAgregandoEnCategoria(null);
    };

    const agregarCategoria = async (nombre) => {
        const trimmed = nombre.trim();
        if (!trimmed || categorias.includes(trimmed)) return;
        const nuevasCats = [...categorias, trimmed];
        setCategorias(nuevasCats);
        setNuevaCategoria('');
        if (servicios.length > 0) await persistir(servicios, nuevasCats);
    };

    const eliminarCategoria = async (cat) => {
        const nuevasCats = categorias.filter(c => c !== cat);
        const nuevosServicios = servicios.map(s => s.categoria === cat ? { ...s, categoria: '' } : s);
        setCategorias(nuevasCats);
        const reordenados = await persistir(nuevosServicios, nuevasCats);
        setServicios(reordenados);
    };

    if (cargando) return (
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 12 }}>
            <div style={{ fontSize: 32 }}>💅</div>
            <p style={{ color: 'var(--pink-800)' }}>Cargando servicios...</p>
        </div>
    );

    const grupos = categorias.length > 0
        ? [...categorias.map(cat => ({ cat, items: servicios.filter(s => s.categoria === cat) })),
           { cat: null, items: servicios.filter(s => !s.categoria || !categorias.includes(s.categoria)) }]
          .filter(g => g.items.length > 0 || g.cat !== null)
        : [{ cat: null, items: servicios }];

    return (
        <div className="app-container">
            <div className="app-header" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <button onClick={onBack} style={{ background: 'none', border: 'none', color: 'var(--pink-600)', fontSize: 20, cursor: 'pointer', padding: '0 4px' }}>←</button>
                <div>
                    <h1>Servicios y precios</h1>
                    <p>{servicios.length} servicio{servicios.length !== 1 ? 's' : ''}</p>
                </div>
            </div>

            <div className="screen-body">
                {/* Sección de categorías */}
                {mostrarCategorias && (
                    <div style={{ background: 'var(--pink-50)', border: '0.5px solid var(--border)', borderRadius: 12, padding: 14, marginBottom: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--pink-900)' }}>🏷️ Categorías</div>
                            {categorias.length === 0 && (
                                <button onClick={() => setMostrarCategorias(false)}
                                    style={{ fontSize: 11, color: 'var(--pink-800)', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}>
                                    Ocultar
                                </button>
                            )}
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
                            {categorias.map(cat => (
                                <div key={cat} style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '5px 10px', background: 'var(--pink-100)', border: '0.5px solid var(--pink-400)', borderRadius: 20 }}>
                                    <span style={{ fontSize: 13, color: 'var(--pink-900)', fontWeight: 500 }}>{cat}</span>
                                    <span style={{ fontSize: 11, color: 'var(--pink-800)' }}>({servicios.filter(s => s.categoria === cat).length})</span>
                                    <button onClick={() => eliminarCategoria(cat)}
                                        style={{ color: '#c62828', background: 'none', border: 'none', fontSize: 16, cursor: 'pointer', lineHeight: 1, padding: '0 2px' }}>×</button>
                                </div>
                            ))}
                        </div>

                        {categorias.length < 10 && (
                            <>
                                <div style={{ fontSize: 12, color: 'var(--pink-800)', marginBottom: 6 }}>Sugerencias:</div>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
                                    {CATEGORIAS_SUGERIDAS.filter(c => !categorias.includes(c)).map(c => (
                                        <button key={c} onClick={() => agregarCategoria(c)}
                                            style={{ padding: '5px 10px', background: '#fff', border: '0.5px solid var(--border)', borderRadius: 20, fontSize: 12, color: 'var(--pink-800)', cursor: 'pointer' }}>
                                            + {c}
                                        </button>
                                    ))}
                                </div>
                            </>
                        )}

                        <div style={{ display: 'flex', gap: 8 }}>
                            <input className="field-input" style={{ flex: 1, fontSize: 13, padding: '8px 12px' }}
                                placeholder="Nueva categoría..." value={nuevaCategoria}
                                onChange={e => setNuevaCategoria(e.target.value)}
                                onKeyDown={e => e.key === 'Enter' && agregarCategoria(nuevaCategoria)} />
                            <button onClick={() => agregarCategoria(nuevaCategoria)}
                                style={{ padding: '8px 14px', background: 'var(--pink-600)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                + Agregar
                            </button>
                        </div>
                    </div>
                )}

                {!mostrarCategorias && (
                    <button onClick={() => setMostrarCategorias(true)}
                        style={{ width: '100%', padding: '8px', background: 'none', color: 'var(--pink-600)', border: '0.5px solid var(--pink-200)', borderRadius: 10, fontSize: 13, cursor: 'pointer', marginBottom: 10 }}>
                        🏷️ Mostrar categorías
                    </button>
                )}

                {/* Lista de servicios */}
                {grupos.map((grupo, gi) => (
                    <div key={gi} style={{ marginBottom: 8 }}>
                        {grupo.cat && (
                            <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--pink-900)', textTransform: 'uppercase', letterSpacing: 0.5, padding: '6px 0 4px', borderBottom: '0.5px solid var(--border)', marginBottom: 4 }}>
                                {grupo.cat} <span style={{ fontWeight: 400, color: 'var(--pink-800)', textTransform: 'none' }}>({grupo.items.length})</span>
                            </div>
                        )}

                        {grupo.items.map((s, idx) => {
                            const idxReal = servicios.indexOf(s);
                            return (
                                <div key={idx} className="item-card" style={{ marginLeft: grupo.cat ? 8 : 0 }}>
                                    <div className="item-icon">💅</div>
                                    <div style={{ flex: 1 }}>
                                        <div className="item-name">{s.servicio}</div>
                                        <div className="item-meta">
                                            ${s.precio}{s.precioMaximo ? `–$${s.precioMaximo}` : ''} · {s.duracion} min
                                            {s.montoAnticipo > 0 ? ` · Anticipo $${s.montoAnticipo}` : ''}
                                        </div>
                                    </div>
                                    <button onClick={() => handleEditar(idxReal)}
                                        style={{ color: 'var(--pink-600)', background: 'none', border: 'none', fontSize: 16, cursor: 'pointer', padding: '4px 6px' }}>✎</button>
                                    <button onClick={() => handleEliminar(idxReal)}
                                        style={{ color: '#c62828', background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', padding: '4px 4px' }}>×</button>
                                </div>
                            );
                        })}

                        {editando !== null && servicios[editando]?.categoria === grupo.cat && (
                            <FormServicio servicio={svcActual} onChange={setSvcActual}
                                onGuardar={handleGuardar}
                                onCancelar={() => { setEditando(null); setSvcActual(servicioVacio()); }}
                                manejaAnticipo={manejaAnticipo} categorias={categorias} />
                        )}

                        {grupo.cat && agregandoEnCategoria === grupo.cat && editando === null && (
                            <FormServicio servicio={svcActual} onChange={setSvcActual}
                                onGuardar={handleGuardar}
                                onCancelar={() => { setAgregandoEnCategoria(null); setSvcActual(servicioVacio()); }}
                                manejaAnticipo={manejaAnticipo} categorias={categorias} />
                        )}

                        {grupo.cat && agregandoEnCategoria !== grupo.cat && editando === null && (
                            <button className="add-btn" style={{ marginLeft: 8, fontSize: 12, padding: '7px' }}
                                onClick={() => { setSvcActual(servicioVacio(grupo.cat)); setAgregandoEnCategoria(grupo.cat); setAgregando(false); }}>
                                + Agregar en {grupo.cat}
                            </button>
                        )}
                    </div>
                ))}

                {editando !== null && !servicios[editando]?.categoria && (
                    <FormServicio servicio={svcActual} onChange={setSvcActual}
                        onGuardar={handleGuardar}
                        onCancelar={() => { setEditando(null); setSvcActual(servicioVacio()); }}
                        manejaAnticipo={manejaAnticipo} categorias={categorias} />
                )}

                {agregando && editando === null && agregandoEnCategoria === null && (
                    <FormServicio servicio={svcActual} onChange={setSvcActual}
                        onGuardar={handleGuardar}
                        onCancelar={() => { setAgregando(false); setSvcActual(servicioVacio()); }}
                        manejaAnticipo={manejaAnticipo} categorias={categorias} />
                )}

                {editando === null && agregandoEnCategoria === null && !agregando && (
                    <button className="add-btn" onClick={() => { setSvcActual(servicioVacio()); setAgregando(true); }}>
                        + Agregar servicio
                    </button>
                )}
            </div>
        </div>
    );
};
